export default __webpack_public_path__ + "static/media/razorpay.7fd236b2.jpeg";